<div class="item" role="listitem">
  <div class="image">
    <div class="bubble align-items-center justify-content-center align-items-center d-flex" [ngClass]="bubbleClassList">
      @if (!useTextIndex) {
        <i class="fas" [ngClass]="bubbleIconClass" aria-hidden="true"></i>
      }
      @if (useTextIndex) {
        <div class="bubble-text text-center">{{ index }}</div>
      }
    </div>
  </div>
  <div class="details">
    <div>
      <ng-content />
    </div>
  </div>
</div>
